import { render, staticRenderFns } from "./template-card.vue?vue&type=template&id=e068a89e&scoped=true"
import script from "./template-card.vue?vue&type=script&lang=js"
export * from "./template-card.vue?vue&type=script&lang=js"
import style0 from "./template-card.vue?vue&type=style&index=0&id=e068a89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e068a89e",
  null
  
)

export default component.exports